import axios from "axios";

const url = process.env.REACT_APP_API_URL;

export async function GetInfoMC(token, ROUTE_URL, number, offset, limit) {
  let response = await axios({
    method: "GET",
    url: `${url}${ROUTE_URL}?kks_psats_info&${number}&offset=${offset}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

// export async function PostControlMC(token, number, data) {
//   let response = await axios({
//     method: "POST",
//     url: `${url}/set_control_mc/${number}`,
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//     data: {
//       ...data,
//     },
//   });
//   return response;
// }

export async function GetTrackNMEA(token, offset, limit) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_knap?track_NMEA&offset=${offset}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

// export async function GetConnMC(token, offset, limit) {
//   let response = await axios({
//     method: "GET",
//     url: `${url}/get_conn_mc?kks_psats_info&offset=${offset}&limit=${limit}`,
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
//   return response;
// }

export async function GetApkKonsul(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/info_state`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function GetKKCinfo(token, offset, limit) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_vpy?kks_status&offset=${offset}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}
